( function( $ ) {
	const facilityResultsWrappers = document.querySelectorAll( '.facility-result__wrap, .facility-details' );
	if( !facilityResultsWrappers.length ) { return; }

	// Using JQuery due to the use of a bootstrap event
	$( facilityResultsWrappers ).on( 'show.bs.modal', moveToBottomOfBody );
	$( 'body' ).on( 'hidden.bs.modal', moveToOriginalPlace );

	document.body.addEventListener( 'facility-result-rendered', closeModals );

	function moveToBottomOfBody( e ) {
		// stash a refrence to the trigger to keep track of the original placement
		e.target.dataset.facilitiesTagsModal = true;
		document.body.appendChild( e.target );
	}

	function moveToOriginalPlace( e ) {
		if( !e.target.dataset.facilitiesTagsModal ) { return; }
		const triggerBtn = document.querySelector( `[aria-controls="${e.target.id}"]` );
		if( triggerBtn ) {
			triggerBtn.after( e.target );
		}
	}

	function closeModals() {
		Array.from( document.querySelectorAll( '.modal.show' ) ).forEach( modal => {
			if( modal.dataset.facilitiesTagsModal ) {
				// it was a modal for the previous results set
				modal.remove();
				const backdrop = document.querySelector( '.modal-backdrop.show' );
				backdrop.remove();

				document.body.classList.remove( 'modal-open' );
				document.body.style.paddingRight = '';
			}
		} );
	}
} )( jQuery );